import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  padding-right: 40px;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const ContentDiv = styled.div`
  padding: 0 2.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const FormBody = styled.div`
  padding: 0 1.375rem;
`;

export const OuterWrapperBackground = styled.div`
    background: #f5f5f5 !important;
}`;

export const PaddingDiv = styled.div`
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
}`;

export const OuterWrapper = styled.div`
  padding: 1.375rem;
}`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 10px;
`;

export const ComponentContainer = styled.div`
  height: 120px;
  overflow: auto;
  margin-bottom: 5px;
`;

export const ContactContainer = styled.div`
  height: auto;
  margin-top: 5px;
`;

export const ErrorLabel = styled.span`
  font-weight: bold;
  color: red;
  font-style: italic;
  float: left;
`;

export const CheckboxGridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const MarginDiv = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;
`;

export const ErrorDiv = styled.div`
  height: auto;
  border: solid 1px red;
  padding: 7px;
`;

export const ErrorLog = styled.div`
  margin: 10px;
`;

export const MarginBottom = styled.div`
  margin-bottom: 15px;
`;

export const ParentDatePicker = styled.div`
  height: max-content;
  margin-top: -6px;
  display: grid !important;
`;

export const TextInputLabel = styled.label`
  margin-left: -7px;
  position: relative !important;
  margin-bottom: -13px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  top: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";

    color: #ea6457;

    font-weight: bold;
  }
`;

export const ContactButton = styled(BaseButton)`
  border: 1px solid ${(props) => props.background};
  background: ${(props) => props.border};
  font-weight: normal;
  width: ${(props) => props.width ?? "auto"};
  margin-right: ${(props) => props.marginRight ?? "0px"};
  margin-left: ${(props) => props.marginLeft ?? "0px"};
  margin-top: ${(props) => props.marginTop ?? "0px"};
  float: ${(props) => props.float ?? "none"};
  height: ${(props) => props.height ?? "auto"};
  margin-bottom: 0px;
`;

export const SpanButton = styled.span`
  margin-left: 10px;
  font-weight: normal;
  width: ${(props) => props.width ?? "auto"};
  float: ${(props) => props.float ?? "none"};
  height: ${(props) => props.height ?? "auto"};
`;
